import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Verify from './pages/Verify';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import BatchManager from './pages/BatchManager';
import Assign from './pages/Assign';
import VerifyQuick from './pages/VerifyQuick';
import UserManager from './pages/UserManager';
import Settings from './pages/Settings';
import History from './pages/History';

function PrivateRoute({ children }) {
  const [auth, setAuth] = useState('checking'); // 'checking' | 'ok' | 'fail'

  useEffect(() => {
    // Token is in an httpOnly cookie — just ask the server if we're authed.
    fetch('/api/auth/me', { credentials: 'include' })
      .then((r) => {
        if (r.ok) setAuth('ok');
        else { localStorage.clear(); setAuth('fail'); }
      })
      .catch(() => { localStorage.clear(); setAuth('fail'); });
  }, []);

  if (auth === 'checking') return null;
  if (auth === 'fail') return <Navigate to="/admin/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public */}
        <Route path="/verify" element={<Verify />} />
        <Route path="/verify-auth-quick/:certNum" element={<VerifyQuick />} />
        <Route path="/" element={<Navigate to="/verify" replace />} />

        {/* Auth */}
        <Route path="/admin/login" element={<Login />} />

        {/* Protected admin */}
        <Route path="/admin" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
        <Route path="/admin/batches" element={<PrivateRoute><BatchManager /></PrivateRoute>} />
        <Route path="/admin/assign" element={<PrivateRoute><Assign /></PrivateRoute>} />
        <Route path="/admin/users" element={<PrivateRoute><UserManager /></PrivateRoute>} />
        <Route path="/admin/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
        <Route path="/admin/history" element={<PrivateRoute><History /></PrivateRoute>} />
      </Routes>
    </BrowserRouter>
  );
}
